import { getYourMetric as getYourMetricM } from "../../mock/home/MockYourMetrics";

export const getYourMetric = async () => {
    return await getYourMetricM();

    //use API
};